var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.7969 56.6562H48.5625C43.8398 56.6562 39.639 58.9333 37 62.447C34.361 58.9333 30.1602 56.6562 25.4375 56.6562H5.20312V68.2188H0V74H74V68.2188H68.7969V56.6562ZM10.9844 68.2188V62.4375H25.4375C29.2062 62.4375 32.421 64.8539 33.6141 68.2188H10.9844ZM40.3859 68.2188C41.5789 64.8539 44.7938 62.4375 48.5625 62.4375H63.0156V68.2188H40.3859Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.3555H11.5625V24.1367H0V18.3555Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4375 18.3555H74V24.1367H62.4375V18.3555Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.01074 37.531L13.0239 31.7498L15.9145 36.7563L5.90137 42.5376L3.01074 37.531Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.989 5.03258L68.0984 0L58.085 5.80727L60.9756 10.8138L70.989 5.03258Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.915 5.80727L5.90161 0L3.01099 5.03258L13.0244 10.8138L15.915 5.80727Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0841 36.7588L60.9747 31.7522L70.9879 37.5335L68.0972 42.54L58.0841 36.7588Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3281 38.4544V46.25C28.3281 51.0317 32.2183 54.9219 37 54.9219C41.7817 54.9219 45.6719 51.0317 45.6719 46.25V38.4544C52.6637 35.0929 57.2344 28.008 57.2344 20.2344C57.2344 9.03421 48.2028 0 37 0C25.7998 0 16.7656 9.03161 16.7656 20.2344C16.7656 28.008 21.3363 35.0929 28.3281 38.4544ZM37 49.1406C35.4061 49.1406 34.1094 47.8439 34.1094 46.25V43.3594H39.8906V46.25C39.8906 47.8439 38.5939 49.1406 37 49.1406ZM37 5.78125C44.9695 5.78125 51.4531 12.2649 51.4531 20.2344C51.4531 26.2687 47.5726 31.7282 41.797 33.8196L39.8906 34.5099V37.5781H34.1094V34.5099L32.203 33.8196C26.4274 31.7282 22.5469 26.2687 22.5469 20.2344C22.5469 12.2649 29.0305 5.78125 37 5.78125Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8692 20.2344L42.7813 16.1465L37 21.9277L31.2188 16.1465L27.1309 20.2344L37 30.1036L46.8692 20.2344Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudy);
export default __webpack_public_path__ + "static/media/study.ab32a10be8cd5c7b23a8c28bb01a7573.svg";
export { ForwardRef as ReactComponent };